import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import './index.css';
import Home from './Home';
import Footer from "./Footer";
import About from "./About";
import Pricing from "./Pricing";
import Login from "./Login";
import Register from "./Register";
import Contacts from "./Contacts";
import reportWebVitals from './reportWebVitals';
import ReactCountryFlag from "react-country-flag";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
        
          {/* <Header /> */}
          <Routes>
              <Route index element={<Home />} />
              <Route path={'/login'} element={<Login />} exact />
              <Route path={'/register'} element={<Register />} exact />
              <Route path={'/contacts'} element={<Contacts />} exact />
              <Route path={'/about'} element={<About />} exact />
              <Route path={'/pricing'} element={<Pricing />} exact />
              {/* <Route path={'/products'} element={<Products />} exact />
              <Route path={'/register'} element={<Register />} exact />
              <Route path={'/login'} element={<Login />} exact />
              <Route path={'/services'} element={<Services />} exact />
              <Route path={'/about'} element={<About />} exact />
              <Route path={'/contacts'} element={<Contacts />} exact /> */}
              {/*<Route path={'/partners'} element={<Partners />} exact />*/}
              {/*<Route path={'/career'} element={<Career />} exact />*/}
              {/*<Route path={'/privacy'} element={<Privacy />} exact />*/}
              {/*<Route path={'/cookies'} element={<Cookies />} exact />*/}
              {/*<Route path={'/terms'} element={<Terms />} exact />*/}
              {/*<Route path={'/help'} element={<Help />} exact />*/}
              {/*<Route path={'/faq'} element={<Faq />} exact />*/}
              {/*<Route path={'/useful'} element={<Useful />} exact />*/}
              {/*<Route path={'/eu'} element={<EU />} exact />*/}
          </Routes>
          <Footer />
      </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
